import classNames from 'classnames'

import styles from './Section.module.scss'

export const Section = (props) => {
    return (
        <section
            className={classNames(
                styles['section'],
                {
                    [styles['section--style-' + props.sectionStyle]]: props.sectionStyle
                },
                props.className,
            )}
            name={props?.anchor}
        >
            <div className={classNames(styles['section__inner'])}>
                {props.children}
            </div>
        </section>
    )
}
